import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './modules/shared-modules/material.module';
import { AuthGuardService } from './services/auth-guard.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { FooterComponent } from './components/footer/footer.component';
import { InitialisationModule } from './modules/route-modules/initialisation/initialisation.module';
import { ItemsDataModule } from './modules/route-modules/items/items.module';
import { LandingPageComponent } from './modules/route-modules/landing-page/landing-page.component';
import { SharedModule } from './modules/shared-modules/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { ResultsModule } from './modules/route-modules/results/results.module';
import { HpModule } from './modules/route-modules/hps/hp.module';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { SpiderwebModule } from './modules/route-modules/spiderweb/spiderweb.module';
import { StatusHpComponent } from './modules/route-modules/hps/approve-hp/status-hp.component';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        OAuthModule.forRoot(),
        AppRoutingModule,
        MaterialModule,
        BrowserAnimationsModule,
        SharedModule,
        InitialisationModule,
        ItemsDataModule,
        ResultsModule,
        HpModule,
        SpiderwebModule, HeaderComponent,
        MainComponent,
        LoginComponent,
        FooterComponent,
        LandingPageComponent,
        StatusHpComponent], providers: [
        AuthGuardService,
        { provide: MAT_DATE_LOCALE, useValue: 'nl-NL' },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
